import { AstNodeCategory, AstNodeType } from './node';
export class ExpressionStatement {
    constructor(token, expression) {
        this.token = token;
        this.expression = expression;
        this.nodeType = AstNodeType.ExpressionStatement;
        this.nodeCategory = AstNodeCategory.Statement;
    }
    get Token() {
        return this.token;
    }
    get Expression() {
        return this.expression;
    }
    set Expression(val) {
        this.expression = val;
    }
    tokenLiteral() {
        var _a;
        return ((_a = this.expression) === null || _a === void 0 ? void 0 : _a.tokenLiteral()) || '';
    }
    toString() {
        if (this.expression) {
            return this.expression.toString();
        }
        return '';
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwcmVzc2lvblN0YXRlbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXN0L0V4cHJlc3Npb25TdGF0ZW1lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxXQUFXLEVBQXlCLE1BQU0sUUFBUSxDQUFDO0FBRTdFLE1BQU0sT0FBTyxtQkFBbUI7SUFDNUIsWUFBb0IsS0FBWSxFQUFVLFVBQXVCO1FBQTdDLFVBQUssR0FBTCxLQUFLLENBQU87UUFBVSxlQUFVLEdBQVYsVUFBVSxDQUFhO1FBRWpFLGFBQVEsR0FBZ0IsV0FBVyxDQUFDLG1CQUFtQixDQUFDO1FBQ3hELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxTQUFTLENBQUM7SUFIVSxDQUFDO0lBS3JFLElBQUksS0FBSztRQUNMLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUN0QixDQUFDO0lBRUQsSUFBSSxVQUFVO1FBQ1YsT0FBTyxJQUFJLENBQUMsVUFBd0IsQ0FBQztJQUN6QyxDQUFDO0lBRUQsSUFBSSxVQUFVLENBQUMsR0FBRztRQUNkLElBQUksQ0FBQyxVQUFVLEdBQUcsR0FBRyxDQUFDO0lBQzFCLENBQUM7SUFFRCxZQUFZOztRQUNSLE9BQU8sQ0FBQSxNQUFBLElBQUksQ0FBQyxVQUFVLDBDQUFFLFlBQVksRUFBRSxLQUFJLEVBQUUsQ0FBQztJQUNqRCxDQUFDO0lBRUQsUUFBUTtRQUNKLElBQUksSUFBSSxDQUFDLFVBQVUsRUFBRTtZQUNqQixPQUFPLElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLENBQUM7U0FDckM7UUFDRCxPQUFPLEVBQUUsQ0FBQztJQUNkLENBQUM7Q0FDSiJ9